import { toast } from "react-toastify";
import API from "../../Api/Api";
import { getPackingsTotalHT, isDefined } from "../../Utils";
import { deleteRecord } from "../../Utils/api";
import { saveAs } from "file-saver";

export const createAvoir =
  (formData, navigate, t) => async (dispatch, getState) => {
    const { user } = getState().userReducer;
    dispatch({ type: "CREATE_AVOIR_LOADING" });
    try {
      const marque = user?.attributes?.marque?.data?.id;
      const { data } = await API.post("/api/avoirs", {
        data: {
          commande: formData?.id,
          reseller: formData?.reseller?.id,
          businessAffiliate: formData?.business_affiliate?.id,
          state: "draft",
          status: "To refund",
          creator: user?.id,
          date: new Date(),
          marque,
        },
      });
      // TEMPORARY SET AVOIR NUMBER TO ID
      await API.put(`/api/avoirs/${data?.data?.id}`, {
        data: {
          number: data?.data?.id,
        },
      });
      navigate({ id: data?.data?.id });
      toast.success(t("Credit has been created"));
    } catch (error) {
      // dispatch({ type: "CURRENT_AVOIRS_ERROR", payload: error });
      toast.error(t("An error occurred while creating the credit"));
    }
  };

export const deleteCurrentAvoir = (id, state, t) => async (dispatch) => {
  let updatedState = null;
  if (state === "edit") {
    updatedState = "completed";
  }
  dispatch({ type: "DELETE_CURRENT_AVOIR_LOADING" });
  try {
    await API.put(`/api/avoirs/${id}`, {
      data: {
        state: updatedState,
      },
    });
    dispatch({ type: "DELETE_CURRENT_AVOIR_SUCCESS", payload: id });
  } catch (error) {}
};

export const addCurrentAvoir = (id, state, navigate) => async () => {
  let updatedState = state;
  if (!state) {
    updatedState = "draft";
  } else if (state === "completed") {
    updatedState = "edit";
  }

  try {
    await API.put(`/api/avoirs/${id}`, {
      data: {
        state: updatedState,
      },
    });
    navigate({ id });
  } catch (error) {}
};

export const getCurrentAvoirs = (navigate) => async (dispatch) => {
  // const { user } = getState().userReducer;
  dispatch({ type: "CURRENT_AVOIRS_LOADING" });
  try {
    const filters = {
      // creator: {
      //   id: {
      //     $eq: user?.id,
      //   },
      // },
      $or: [
        {
          state: {
            $eq: "draft",
          },
        },
        {
          state: {
            $eq: "edit",
          },
        },
      ],
    };

    const populate = {
      reseller: true,
      avoirPackings: {
        populate: {
          packings: {
            populate: {
              avoirPacking: {
                populate: {
                  createdPackings: true,
                },
              },
              approvisionnement: true,
              model: {
                fields: ["productType", "name", "name_en"],
                populate: {
                  attachments: {
                    fields: [],
                    populate: {
                      file: {
                        fields: ["url"],
                        // populate: true,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      commande: {
        populate: {
          packings: {
            populate: {
              approvisionnement: true,
              model: {
                fields: ["productType", "name", "name_en"],
                populate: {
                  attachments: {
                    fields: [],
                    populate: {
                      file: {
                        fields: ["url"],
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    };

    const { data } = await API.get("/api/avoirs", {
      params: {
        filters,
        populate,
      },
    });
    dispatch({ type: "CURRENT_AVOIRS_SUCCESS", payload: data?.data });
    navigate && !data?.data?.length > 0 && navigate();
  } catch (error) {
    dispatch({ type: "CURRENT_AVOIRS_ERROR", payload: error });
  }
};

const createNewPacking = async (packing, createdFrom) => {
  try {
    const { data } = await API.post(`/api/packings`, {
      data: {
        ...packing?.attributes,
        model: packing?.attributes?.model?.data?.id,
        approvisionnement: packing?.attributes?.approvisionnement?.data?.id,
        status: "in-stock",
        discount: 0,
        globalDiscount: 0,
        soldPrice: null,
        sold: false,
        hidden: false,
        createdFrom,
      },
    });
    return data?.data?.id;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const shouldCreatePacking = (packings, totalHT) => {
  const packingsTotalHT = getPackingsTotalHT(packings);

  return packingsTotalHT === +totalHT;
};

export const updateAvoir =
  (id, formData, isParticulier, t, navigate) => async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_AVOIR_LOADING" });
      const {
        total,
        tva,
        packings,
        deletedAvoirPackings = [],
        ...rest
      } = formData;

      for (const avoirPacking of deletedAvoirPackings) {
        if (isDefined(avoirPacking?.id)) {
          await deleteRecord(avoirPacking?.id, "avoir-packings");

          const createdPackings =
            avoirPacking?.attributes?.createdPackings?.data;
          if (createdPackings) {
            for (const createdPacking of createdPackings) {
              await deleteRecord(createdPacking?.id, "packings");
            }
          }
        }
        if (isDefined(avoirPacking?.packingId)) {
          await API.put(`/api/packings/${avoirPacking?.packingId}`, {
            data: {
              hidden: false,
            },
          });
        }
      }

      for (let idx = 0; idx < packings.length; idx++) {
        const currentPacking = packings[idx]?.length > 0 && packings[idx][0];

        let avoirPackingId = null;

        if (currentPacking?.attributes?.avoirPacking?.data) {
          avoirPackingId = currentPacking?.attributes?.avoirPacking?.data?.id;
          await API.put(`/api/avoir-packings/${avoirPackingId}`, {
            data: {
              totalHT: total[idx]?.totalHT ?? 0,
              packings: packings[idx]?.map((el) => el?.id),
            },
          });
        } else if (currentPacking) {
          const { data } = await API.post(`/api/avoir-packings`, {
            data: {
              totalHT: total[idx]?.totalHT ?? 0,
              avoir: id,
              packings: packings[idx]?.map((el) => el?.id),
            },
          });
          avoirPackingId = data?.data?.id;
        }

        const group = packings[idx];

        if (group?.length > 0) {
          if (
            group[0]?.attributes?.avoirPacking?.data?.attributes
              ?.createdPackings?.data?.length > 0
          ) {
            const createdPackings =
              group[0]?.attributes?.avoirPacking?.data?.attributes
                ?.createdPackings?.data;
            if (!shouldCreatePacking(group, total[idx]?.totalHT)) {
              await API.put(`/api/packings/${group[0].id}`, {
                data: {
                  hidden: false,
                },
              });
              for (const createdPacking of createdPackings) {
                await deleteRecord(createdPacking?.id, "packings");
              }
            }
          } else if (shouldCreatePacking(group, total[idx]?.totalHT)) {
            await API.put(`/api/packings/${group[0].id}`, {
              data: {
                hidden: true,
              },
            });
            for (const packing of group) {
              await createNewPacking(packing, avoirPackingId);
            }
          }
        }
      }

      const totalHT =
        total?.reduce(
          (acc, item) =>
            acc + (!isNaN(item.totalHT) ? Number(item.totalHT) : 0),
          0,
        ) + (!isNaN(rest?.delivery) ? Number(rest?.delivery) : 0);

      const { data } = await API.put(`/api/avoirs/${id}`, {
        data: {
          ...rest,
          totalHT: isParticulier ? totalHT / 1.2 : totalHT,
          state: "completed",
          tva:
            tva > 0
              ? isParticulier
                ? (totalHT / 1.2) * 0.2
                : totalHT * 0.2
              : 0,
          totalTTC: isParticulier ? totalHT : tva > 0 ? totalHT * 1.2 : totalHT,
          deliveryTotal: rest?.delivery,
        },
      });

      await dispatch(getCurrentAvoirs());
      dispatch({ type: "UPDATE_AVOIR_SUCCESS", payload: data?.data });

      toast.success(t("Credit has been updated"));
      navigate && navigate();
    } catch (error) {
      toast.error(t("An error occurred while updating the credit"));
    }
  };

export const fetchAvoirs =
  (page = 1, search, signal) =>
  async (dispatch, getState) => {
    console.log({ signal });
    dispatch({ type: "AVOIRS_LOADING" });
    try {
      const { user } = getState().userReducer;
      const marque = user?.attributes?.marque?.data?.id;

      const pageSize = 10;

      const searchFilters =
        search?.trim()?.length > 0
          ? {
              $or: [
                {
                  number: { containsi: search },
                },
                {
                  businessAffiliate: {
                    company: {
                      containsi: search,
                    },
                  },
                },
                {
                  reseller: {
                    name: {
                      containsi: search,
                    },
                  },
                },
              ],
            }
          : {};

      const query = {
        sort: "createdAt:desc",
        populate: {
          attachment: {
            populate: {
              file: true,
            },
          },
          creator: {
            fields: ["firstName", "lastName"],
          },
          businessAffiliate: {
            fields: ["company"],
          },
          reseller: {
            fields: ["name"],
          },
          commande: true,
        },
        filters: {
          ...searchFilters,
          marque: {
            id: {
              $eq: marque,
            },
          },
        },
      };
      const { data } = await API.get(
        "/api/avoirs",
        {
          params: {
            ...query,
            pagination: {
              page,
              pageSize,
            },
          },
        },
        {
          signal,
        },
      );
      dispatch({ type: "AVOIRS_SUCCESS", payload: data });
    } catch (error) {
      dispatch({ type: "AVOIRS_ERROR", payload: error });
    }
  };

export const updateAvoirStatus = (id, status, t) => async (dispatch) => {
  dispatch({ type: "UPDATE_STATUS_AVOIR_LOADING" });
  try {
    await API.put(`/api/avoirs/${id}`, {
      data: {
        status,
      },
    });
    dispatch({ type: "UPDATE_STATUS_AVOIR_SUCCESS", payload: { id, status } });
    toast.success(t("Credit has been updated"));
  } catch (error) {
    toast.error(t("An error occurred while updating the credit"));
  }
};

export const updateAvoirComment = (id, comment, t) => async (dispatch) => {
  dispatch({ type: "UPDATE_COMMENT_AVOIR_LOADING" });
  try {
    await API.put(`/api/avoirs/${id}`, {
      data: {
        comment,
      },
    });
    dispatch({
      type: "UPDATE_COMMENT_AVOIR_SUCCESS",
      payload: { id, comment },
    });
    toast.success(t("Credit has been updated"));
  } catch (error) {
    toast.error(t("An error occurred while updating the credit"));
  }
};

export const deleteAvoir = (id, t) => async (dispatch) => {
  dispatch({ type: "DELETE_AVOIR_LOADING" });
  try {
    const { data } = await API.get(`/api/avoirs/${id}`, {
      params: {
        populate: {
          avoirPackings: {
            populate: {
              createdPackings: true,
            },
          },
        },
      },
    });

    const avoirPackings = data?.data?.attributes?.avoirPackings?.data ?? [];

    for (const avoirPacking of avoirPackings) {
      if (isDefined(avoirPacking?.id)) {
        await deleteRecord(avoirPacking?.id, "avoir-packings");
        const createdPackings = avoirPacking?.attributes?.createdPackings?.data;

        for (const createdPacking of createdPackings) {
          if (isDefined(createdPacking?.id)) {
            await deleteRecord(createdPacking?.id, "packings");
          }
        }
      }
    }

    await deleteRecord(id, "avoirs");

    dispatch({ type: "DELETE_AVOIR_SUCCESS", payload: id });

    toast.success(t("Credit has been deleted"));
  } catch (error) {
    console.log(error);
    toast.error(t("An error occurred while deleting the credit"));
  }
};

export const generateInvoice = (id, t) => async (dispatch) => {
  try {
    dispatch({ type: "AVOIR_LOADING" });
    await API.post("api/generateAvoir", {
      data: {
        avoirId: id,
      },
    });

    const query = {
      populate: {
        attachment: {
          populate: {
            file: true,
          },
        },
        creator: {
          fields: ["firstName", "lastName"],
        },
        businessAffiliate: {
          fields: ["company"],
        },
        reseller: {
          fields: ["name"],
        },
        commande: true,
      },
    };
    const { data } = await API.get(`/api/avoirs/${id}`, {
      params: {
        ...query,
      },
    });
    dispatch({ type: "AVOIR_SUCCESS", payload: data?.data });
    toast.success(t("Credit has been generated"));
  } catch (error) {
    dispatch({ type: "AVOIR_ERROR" });
    toast.success(t("An error occurred while generating the credit"));
  }
};

export const downloadInvoice = (url, name, t) => async (dispatch) => {
  try {
    dispatch({ type: "AVOIR_LOADING" });

    const response = await API.get(url, {
      responseType: "blob",
    });

    saveAs(response.data, name);

    dispatch({ type: "DOWNLOAD_AVOIR_SUCCESS" });
  } catch (error) {
    dispatch({ type: "AVOIR_ERROR" });
    toast.error(t("An error occurred while downloading the credit"));
  }
};
